import { render } from "./zcfgResource.vue?vue&type=template&id=72230265&scoped=true"
import script from "./zcfgResource.vue?vue&type=script&lang=js"
export * from "./zcfgResource.vue?vue&type=script&lang=js"

import "./zcfgResource.vue?vue&type=style&index=0&id=72230265&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72230265"]])

export default __exports__